<template>
  <div class="mod-web-registration-page">
    <div :class="bem('main')">
      <p class="mod-web-registration-page__back-btn" @click="goBack">
        {{ $t('content.commonBackText') }}
      </p>
      <h1 :class="bem('title')">
        <span>{{ detail.title }}</span>
      </h1>
      <section :class="bem('sessions-wrap')">
        <p :class="bem('sub-title')">
          {{ $t('content.activityTitleSession') }}
        </p>
        <sessions :list="detail.scenes" :value="currentSession" @change="handleChangeScene" :col="isPc ? 2 : 1"></sessions>
      </section>
      <section :class="bem('tickets-wrap')">
        <p :class="bem('sub-title')">
          {{ $t('content.activityTitleTickets') }}
        </p>
        <tickets :list="tickets" v-model="selectTicket" :col="isPc ? 2 : 1"></tickets>
      </section>
      <section :class="bem('quantity-wrap')">
        <p :class="bem('sub-title')">
          {{ $t('content.activityTitleQuantity') }}
        </p>
        <stepper v-model="quantity" :max="calcLimit"></stepper>
      </section>
      <section :class="bem('auto-section')">
        <section :class="bem('add-wrap')">
          <p :class="bem('sub-title')">
            {{ $t('content.activityTitleAddDetails') }}
          </p>
          <nio-form :config="formConf" ref="form"></nio-form>
        </section>
        <section :class="bem('tips-wrap')">
          <p :class="bem('sub-title')">
            {{ $t('content.activityTitleAttention') }}
          </p>
          <content-render :class="bem('attention-section')"
                          :content="detail.tips"></content-render>
        </section>
      </section>
      <section>
        <p :class="bem('check-tips')">
          <nio-check v-model="hasCheck" :class="bem('check-btn')"></nio-check>
          {{ $t('content.registrationAgreeText') }}
          <span :class="bem('link')" @click="handleViewClause('app-terms')">{{ $t('content.registrationLinkText') }}</span>
          <!-- {{ $t('content.registrationAgreeText2') }}
          <span :class="bem('link')" @click="handleViewClause('privacy-notice')">{{ $t('content.registrationPrivacyText') }}</span> -->
        </p>
        <nio-button :class="[bem('registration-btn'), (hasCheck && !loadingData) ? '' : 'disabled']"
                    @click="handleRegistration">
          <van-loading v-if="loadingData" color="#FFFFFF" size="20px">{{ $t('content.activityAttendBtn') }}</van-loading>
          <span v-else>{{ $t('content.activityAttendBtn') }}</span>
        </nio-button>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast, Loading } from 'vant';

import ContentRender from '@/components/common/ContentRender/Index';
import NioForm from '@/components/common/NioForm';

import Stepper from '@/components/ui/Stepper';
import NioCheck from '@/components/ui/NioCheck';
import NioButton from '@/components/ui/NioButton';

import Sessions from '@/components/web_activity/Sessions';
import Tickets from '@/components/web_activity/Tickets';
import {
  baseMixin, scrollBehaviorMixin, supreme
} from '@/supreme-core';
import util from '@/util/util';
import {
  jump, goto//, getWebUrl
} from '@/util/common/jump';
import {bffClient} from '~/client'
import {formatActivityData, formatFormConfig} from '@/util/common/format';

import {CACHE_KEYS} from '@/assets/js/constant';
import nav from '@/assets/images/icon/icon_navigation_28.png';

Vue.use(Loading);

export default {

  name: 'Index',
  mixins: [baseMixin, scrollBehaviorMixin],
  components: {
    ContentRender,
    Sessions,
    Tickets,
    Stepper,
    NioForm,
    NioCheck,
    NioButton
  },
  data(){
    return {
      detail: {
        tips: {},
        scenes: [],
        limit: 1
      },
      currentSession: supreme.localCache.get(CACHE_KEYS.SELECTED_SCENE) || 0,
      selectTicket: 0,
      quantity: 1,
      hasCheck: false,
      icons: {
        nav
      },
      loadingData: false,
      clientWidth: 0
    };
  },
  mounted(){
    this.initData();
    this.clientWidth = window.innerWidth || document.body.clientWidth;
  },
  created(){
  },
  computed: {
    isInWebview(){
      return util.isInWebview();
    },
    costDesc(){
      return this.$t('content.activityCostDesc', {cost: this.detail.cost});
    },
    tickets(){
      const cur = this.detail.scenes[this.currentSession];
      let tickets = [];

      if (cur && cur.tickets){
        tickets = cur.tickets.map(item => {
          let result = {amount: item.amount, available_count: item.available_count};
          let type = this.detail.ticketTypes[item.type];

          if (type){
            result.name = type.name;
          }
          result.disabled = !item.available;
          return result;
        });
      }
      return tickets;
    },
    formConf(){
      let conf = [];
      const scene = this.detail.scenes[this.currentSession];

      if (scene && scene.tickets && scene.tickets[this.selectTicket] && scene.tickets[this.selectTicket].type){
        conf = formatFormConfig(this.detail.ticketTypes[scene.tickets[this.selectTicket].type].widgets);
      }
      return conf;
    },
    calcLimit(){
      if (this.tickets && this.tickets[this.selectTicket] && this.tickets[this.selectTicket].available_count < this.detail.limit){
        return this.tickets[this.selectTicket].available_count;
      }
      return this.detail.limit;
    },
    limitDesc(){
      return this.$t('content.activityLimitDesc', {limit: this.calcLimit});
    },
    isPc() {
      return this.clientWidth > 1023;
    }
  },
  beforeDestroy(){
  },
  methods: {
    goBack() {
      const {query, params} = this.$route;
      // if (query.from && query.from === 'schedule') {
      //   history.back();
      // } else {
      //   location.href = `${location.origin}/${params.languages}/activity_detail/index?id=${query.id}`;
      // }
      location.href = `${location.origin}/${params.languages}/activity_detail/index?id=${query.id}`;
    },
    initData(){
      const {from, id} = this.$route.query;

      if (from === 'schedule' && id){
        // 从行程单进入报名页面
        this.fetchDetailData(id);
      } else {
        this.detail = supreme.localCache.get(CACHE_KEYS.DETAIL);
        if (!this.detail.scenes[this.currentSession].available){
          this.currentSession = this.setDefaultIndex(this.detail.scenes);
        }
      }
    },
    fetchDetailData(id){
      this.loadingData = true;
      bffClient.getActivityDetail(id).then(data => {
        this.loadingData = false;
        const detail = formatActivityData(data);
        if (detail.status !== 'registrable'){
          history.back();
          return;
        }
        this.detail = detail;
        supreme.localCache.set(CACHE_KEYS.DETAIL, detail);
        if (!this.detail.scenes[this.currentSession].available){
          this.currentSession = this.setDefaultIndex(this.detail.scenes);
        }
      }).catch(err => {
        this.loadingData = false;
        this.pageError = true;
      })
    },
    setDefaultIndex(list){
      // 设置场次 & 票种默认选中项
      let defaultIndex = 0;

      while (!list[defaultIndex].available && defaultIndex < list.length){
        defaultIndex++;
      }
      return defaultIndex;
    },
    handleChangeScene(index){
      this.currentSession = index;
      this.selectTicket = this.setDefaultIndex(this.detail.scenes[index].tickets);
    },
    handleRegistration(){
      const {id} = this.detail;
      const currentScene = this.detail.scenes[this.currentSession];
      const {type} = currentScene.tickets[this.selectTicket];
      const senceId = currentScene.id;

      if (!id || !senceId){
        return;
      }

      // 不随票数增减变化表单逻辑
      this.$refs.form.validateAll().then(formData => {
        const param = {
          count: this.quantity,
          type,
          forms: [this.filterFormData(formData)]
        };

        bffClient.registrationActivity({
          activityId: id,
          sceneId: senceId
        },  param)
          .then(res => {
            Toast(this.$t('content.commonOperateSuccess'));
            setTimeout(() => {
              location.href = `${location.origin}/${this.$route.params.languages}/agenda/${res.id}`;
            }, 1000);
          })
          .catch((err, msg) => {
            Toast(msg || this.$t('content.commonOperateFail'));
            this.fetchDetailData(this.detail.id);
          })
      });
    },
    filterFormData(data){
      const newData = JSON.parse(JSON.stringify(data));

      this.formConf.forEach(item => {
        if (!item.required && !newData[item.key]){
          delete newData[item.key];
        } else if (!item.required && newData[item.key].calling_code && !newData[item.key].number){
          delete newData[item.key];
        }
      });
      return newData;
    },
    handleViewClause(path){
      const conf = util.getEnvInfo();
      const { lang, region } = this.$location
      if (conf && conf.policyUrl){
        goto(`${conf.policyUrl}/#/${path}?lang=${lang}_${region}&region=${region}`, {useNative: false});
      }
    },
    /* ===========================
             * BEM
             * ===========================
             */
    bem(e, m){
      let classStr = `mod-web-registration-page__${e}`;

      if (m){
        classStr += `--${classStr}`;
      }
      return classStr;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/standard';
@import '@/assets/scss/mixins';

.mod-web-registration-page {
  overflow: hidden;
  padding-bottom: sizeTrans(80);
  text-align: left;
  color: $color_mb1_front;

  ::v-deep .common-nio-form .ui-input {
    font-size: sizeTrans(16);
  }

  &__main {
    max-width: 1100px;
    margin: 0 auto;
    padding-top: sizeTrans(88);
    @include pagePadding();
  }

  &__back-btn {
    position: relative;
    margin-bottom: sizeTrans($space_30);
    font-size: sizeTrans(20);
    line-height: sizeTrans(32);
    cursor: pointer;
    &:before {
      content: '';
      position: absolute;
      left: sizeTrans(-40);
      top: sizeTrans(4);
      width: sizeTrans(24);
      height: sizeTrans(24);
      background-image: url("../../../../assets/images/activity/goback.png");
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  &__title {
    // @include title_m();
    margin-bottom: sizeTrans(50);
    @include font_h1_xl();
    white-space: pre-line;
    word-break: break-word;
  }

  &__sessions-wrap,
  &__tickets-wrap,
  &__add-wrap {
    padding-bottom: sizeTrans(30);
  }

  &__tips-wrap {
    margin-left: sizeTrans($space_20);
  }

  &__auto-section {
    width: 100%;
    display: flex;
    justify-content: space-between;

    > section {
      flex: 1;
    }
  }

  &__quantity-wrap {
    padding-bottom: sizeTrans(52);
  }

  &__sub-title {
    margin-bottom: sizeTrans($space_20);
    @include font_h2_s();
  }
  &__check-btn {
    margin-left: sizeTrans(-$space_10);
    cursor: pointer;
  }
  &__check-tips {
    // margin-top: sizeTrans($space_60);
    margin-bottom: sizeTrans(24);
    @include font_tips_s();
  }

  &__link {
    padding: 0 sizeTrans($space_5);
    color: $color_bs1_front;
    text-decoration: underline;
    cursor: pointer;
  }

  &__registration-btn {
    width: sizeTrans(249);
    margin-top: sizeTrans(77);
  }

  &__attention-section.content-section{
    overflow: hidden;
    // 图片样式顶格
    ::v-deep .image-list,
    ::v-deep .title,
    ::v-deep .paragraph,
    ::v-deep .heading,
    ::v-deep .code-block,
    ::v-deep .list,
    ::v-deep .blockquote,
    ::v-deep .image {
      margin-top: 0;
    }
    font-size: sizeTrans(14);
    line-height: sizeTrans(20);
  }

  @include touch {
    &__main {
      padding-top: sizeTrans(70);
    }

    &__auto-section {
      display: block;
    }

    &__back-btn {
      margin-bottom: sizeTrans($space_20);
      font-size: sizeTrans(16);
      line-height: sizeTrans(20);
      margin-left: sizeTrans(20);
      &:before {
        width: sizeTrans(18);
        height: sizeTrans(18);
        top: sizeTrans(0);
        left: sizeTrans(-20);
      }
    }

    &__title {
      margin-bottom: sizeTrans($space_20);
      font-size: sizeTrans(24);
      line-height: sizeTrans(30);
    }

    &__sub-title {
      margin-bottom: sizeTrans($space_10);
    }

    &__sessions-wrap,
    &__tickets-wrap,
    &__add-wrap {
      padding-bottom: sizeTrans($space_10);
    }

    &__quantity-wrap {
      padding-bottom: sizeTrans($space_20);
    }

    &__tips-wrap {
      margin-left: 0;
    }

    &__check-tips {
      margin-top: sizeTrans($space_20);
    }

    &__registration-btn {
      width: 100%;
      margin-top: sizeTrans(14);
    }
  }
}
</style>
